import {
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputAdornment,
  Box,
  Typography,
  Stack,
  FormControl,
  OutlinedInput,
  ListItemButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { CustomeDialog, Loader, useStoreSelectDialog } from "../../../shared";
import { StoreUpdateDialog } from "../components/StoreUpdateDialog";
import { useStoreDetailsTemplates } from "../hooks";
import CloseIcon from "@mui/icons-material/Close";
import InfiniteScroll from "react-infinite-scroll-component";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { arraySort } from "../../../utils";

export const CreateStoreAssignTab = (props) => {
  const {
    state: states,
    handleAlertClickOpen,
    templates,
    setTemplates,
    id,
    onClose = null,
  } = props;
  const templateId = states?.templateDetails?.data?.template_id
    ? states?.templateDetails?.data?.template_id
    : id;

  const {
    assignedStoreState,
    assingedStoreListQueryTemplate,
    onChangeStoreEffectiveDate,
    state: dataState,
    setState,
    handleStoreToRecipe,
    handleStoreDialogSelect,
    handleModal,
  } = useStoreDetailsTemplates({
    templateId: templateId,
    isAssignedstoreList: true,
    templates,
  });
  const handleOnSubmit = async () => {
    await handleStoreToRecipe();
     handleAlertClickOpen(false, templateId);
    if (typeof onClose === "function") onClose(templateId);
  };
  const { selectedStores, alreadySelectedStores } =
    dataState.selectStoreDialogDetails;

  const {
    listQuery: { data, isLoading },
    state,
    HandleSearchFilter,
  } = useStoreSelectDialog();

  useEffect(() => {
    setTemplates((draft) => {
      draft.selectedStores = selectedStores;
    });
  }, [selectedStores]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Stack maxHeight={"calc(90vh - 128px)"}>
        <FormControl
          size="small"
          fullWidth={true}
          sx={{ py: "8px", px: "16px" }}
        >
          <OutlinedInput
            placeholder="Search"
            sx={{
              height: "48px",
              ".MuiOutlinedInput-input": {
                pl: "0px !important",
              },
            }}
            size="small"
            value={state.search}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon size="large" />
              </InputAdornment>
            }
            endAdornment={
              state.search && (
                <InputAdornment
                  sx={{ cursor: "pointer" }}
                  onClick={(e) => {
                    HandleSearchFilter("initial", "");
                  }}
                  position="end"
                >
                  <CloseIcon size="large" />
                </InputAdornment>
              )
            }
            fullWidth
            onChange={(e) => {
              HandleSearchFilter("search", e.target.value);
            }}
          />
        </FormControl>
        <Box
          id="scrollableDiv"
          sx={{ height: "100%", overflow: "auto" }}
          fullWidth
        >
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            dataLength={data?.length}
            next={null}
            hasMore={null}
            loader={
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                Loading...
              </Box>
            }
          >
            {data.length > 0 ? (
              <List
                sx={{
                  width: "100%",
                  backgroundColor: "background.paper",
                  py: "8px",
                }}
              >
                {arraySort(data, "name").map((value) => {
                  // Sort stores alphabetically by name
                  const stores = Array.isArray(value?.stores)
                    ? arraySort(value.stores, "name")
                    : [];

                  // Filter stores to only include those matching the search input
                  const filteredStores = stores.filter((store) =>
                    store.name
                      .toLowerCase()
                      .includes(state.search.toLowerCase())
                  );

                  if (filteredStores.length === 0) return null;

                  return (
                    <>
                      {stores.length === 0 ? (
                        ""
                      ) : (
                        <ListOfState
                          key={value.id}
                          value={{ ...value, stores: filteredStores }}
                          labelId={`checkbox-list-label-${value.id}`}
                          handleStoreDialogSelect={handleStoreDialogSelect}
                          isSelected={(id) => selectedStores.includes(id)}
                          selectedStores={selectedStores}
                          alreadySelectedStores={alreadySelectedStores}
                          isSearchActive={!!state.search}
                        />
                      )}
                    </>
                  );
                })}
              </List>
            ) : (
              <Stack
                justifyContent="center"
                alignItems="center"
                height="calc(90vh - 200px)"
              >
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  color="text.secondary"
                  fontWeight={400}
                >
                  No stores added yet
                </Typography>
              </Stack>
            )}
          </InfiniteScroll>
        </Box>
      </Stack>

      {templates?.isStoreOpen === true && (
        <CustomeDialog
          PaperProps={{
            sx: {
              minWidth: "570px",
              minHeight: "280px",
            },
          }}
          open={templates?.isStoreOpen}
          handleClose={() => handleModal("store-dialog-add", false)}
          title={
            <Typography
              sx={{
                padding: "20px 20px 8px 20px",
                fontWeight: "500",
                fontSize: "20px",
                lineHeight: "24.2px",
                width: "590px",
              }}
            >
              From when should this template change be applied to generated
              production charts?
            </Typography>
          }
          content={
            <StoreUpdateDialog
              onSubmit={handleOnSubmit}
              templates={dataState}
              onChangeStoreEffectiveDate={onChangeStoreEffectiveDate}
              setTemplates={setState}
              handleClose={() => {
                handleAlertClickOpen(false, templateId);
                // handleClose()
              }}
              state={assignedStoreState}
              isDisabled={assingedStoreListQueryTemplate?.isPending}
            />
          }
        />
      )}
    </>
  );
};

function ListOfState({
  value,
  labelId,
  handleStoreDialogSelect,
  selectedStores,
  alreadySelectedStores,
  isSearchActive,
}) {
  const [open, setOpen] = useState(isSearchActive || false);

  const handleExpandClick = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const isSelectedCheck = (value) => {
    if (value.stores) {
      const subArray = value?.stores?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedStores.filter((val) => subArray.includes(val));
      return subArray.every((val) => commonIDs1.includes(val));
    } else {
      return isSelected(value.id);
    }
  };
  const isSelected = (id) => {
    if (selectedStores.includes(id)) {
      return true;
    } else {
      return selectedStores.includes(id);
    }
  };
  const isDisabled = (value) => {
    return alreadySelectedStores.includes(value);
  };
  const isDisable = (value) => {
    if (value.stores) {
      const subArray = value?.stores?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedStores.map((val) => subArray.includes(val));
      return subArray.every((val) => commonIDs1.includes(val));
    } else {
      return selectedStores.includes(value.id);
    }
  };
  return (
    <>
      <ListItem key={value} sx={{ py: "2px" }}>
        <ListItemButton
          role={undefined}
          dense
          sx={{
            borderRadius: "8px",
          }}
          selected={isSelectedCheck(value)}
        >
          <ListItemIcon
            sx={{
              minWidth: "32px",
            }}
          >
            <Checkbox
              edge="end"
              disabled={isDisable(value)}
              checked={isSelectedCheck(value)}
              onChange={(e) => {
                handleStoreDialogSelect(value, e);
                setOpen(true);
              }}
              disableRipple
              inputProps={{ "aria-labelledby": labelId }}
            />
          </ListItemIcon>
          <ListItemText
            id={labelId}
            primary={value.name}
            onClick={() => setOpen(!open)}
          />
          <ExpandMoreIcon
            sx={{
              color: "#999999",
              transform: open ? "rotate(180deg)" : "",
              transition: "transform 0.3s",
            }}
            onClick={handleExpandClick}
          />
        </ListItemButton>
      </ListItem>

      {open &&
        value.stores.map((v, index) => {
          const selected = isSelected(v.id);
          return (
            <ListItem key={index} sx={{ py: "2px" }}>
              <ListItemButton
                role={undefined}
                dense
                sx={{
                  borderRadius: "8px",
                }}
                selected={selected}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "32px",
                    marginLeft: "12px",
                  }}
                >
                  <Checkbox
                    edge="end"
                    checked={selected}
                    disabled={isDisabled(v.id)}
                    onChange={() => handleStoreDialogSelect(v)}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText primary={v.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
    </>
  );
}
